<template>
<!-- 
  Author: sss
  Date: 2021-10-25
  content: 手机端首页
 -->
  <div>
    <navigation></navigation>
    <links :show="is_links"></links>
    <div class="swiper-container">
      <div class="swiper-wrapper">
        <div class="swiper-slide page-slide screenHeight" data-index='0'>
          <div class="index-top">
            <!--封面-->
            <section class="first-page main" id="first">
              <div class="wrap">
                <div class="video-bg" v-show="run" id="videoBg">
                  <video id="video" src="https://vbdata-fe-static.oss-cn-beijing.aliyuncs.com/public/video/short_batch.mp4?versionId=CAEQFxiBgMC0o4.q6hciIDQ2OTk4NzFhMmJmMTRlNDZiZTJjYTI0YTYyMzBlYzgx" loop playsinline="true"></video>
                </div>
                <div class="mask" id="mask">
                  <div class="fadeOut-up" v-show="run"></div>
                  <div class="title">
                    <img src="~/img/main/index/title.png">
                    <div class="enter-video" @click="runVideo" :class="{'noBack': is_links}">
                      <div v-show="!is_links">立即进入</div>
                    </div>
                  </div>
                  <div class="fadeOut-down" v-show="run"></div>
                  <div class="slide-icon" v-show="run"><img src="~/img/main/logo/slide-down.png" alt=""></div>
                </div>
              </div>
            </section>
          </div>
        </div>
        <div class="swiper-slide page-slide scroll-wrap" data-index='1' v-if="run">
          <div class="index-bottom" style="height: 100%; overflow: auto;">
            <!--介绍-->
            <section class="second-page main">
              <div class="list-content">
                <div class="concept words">
                  <img src="~/img/main/index/concept.png" alt="">
                </div>
                <div class="info" id="info">
                  <div class="list-title">未来医疗100强榜介绍</div>
                </div>
              </div>
              <div class="second-content">
                <div class="info-image">
                    <div class="slider-image">
                      <img src="~/img/main/index/title_blue.png" alt="">
                    </div>
                  </div>
                  <div class="introduce">
                    <div class="introduce-image">
                      <img src="~/img/main/index/introduce1.png" alt="">
                    </div>
                    <div class="introduce-words">
                      <p>创立于2015年的未来医疗100强榜是由动脉网、VB100、蛋壳研究院推出的国内第一个针对非上市企业的创新医疗领域榜单，旨在遴选真正代表未来医疗的中国创新医疗者，推动健康医疗产业的创新变革进程。六年来，未来医疗100强榜单体系不断丰富，逐步构建形成面向企业、投资机构、医院、产业园区的全球性创新医疗健康生态榜单。</p>
                    </div>
                  </div>
              </div>
            </section>
            <!--百强企业动态-->
            <section class="third-page main">
              <div class="list-content">
                <div class="right-img">
                  <img src="~img/main/index/introduce3.png" alt="">
                </div>
                <div class="words trend-img">
                  <img src="~/img/main/index/trends.png" alt="" style="margin-left: 60px;">
                </div>
                <div class="info trends">
                  <div class="list-title">百强企业动态</div>
                </div>
                <div class="trends-content">
                  <div class="tags">
                    <span v-for="item in article_type_list" :key="item.id" :class="active == item.id ? 'active' : ''" @click="changeStatus(item.id)">{{item.name}}</span>
                  </div>
                  <div class="result">
                    <div class="result-tr">
                      <div class="result-td" v-for="(item, index) in article_list" :key="item.article_id">
                        <div class="td-content">
                          <p class="index-name">{{getArticleIndex(index + 1)}}</p>
                          <p class="company-name over-p1">{{item.short_name}}</p>
                          <img :src="getLogo(item.article_logo_path)" alt="暂无" class="logo">
                          <a :href="'http://vcbeat.top/'+ item.article_id" target="_blank" style="color: #FFFFFF"><p class="article-title over-p3">{{item.article_title}}</p></a>
                          <p class="article-info over-p2">{{item.article_summary}}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <!--百位人物专访-->
            <section class="fourth-page main">
                <div class="list-content">
                  <div class="info">
                    <div class="list-title">百强人物专访</div>
                  </div>
                  <div class="interview words">
                    <img src="~/img/main/index/interview.png" alt="">
                  </div>
                  <div class="interview-content">
                    <div class="interview-tr" v-for="item in people_list" :key="item.id" v-show=" item.peopley.length > 0">
                      <div class="people-type list-content" style="padding-top: 30px;"><span class="type-name">{{item.name}}</span></div>
                        <div class="interview-wrapper wrap">
                          <div class="interview-td"  v-for="people, index in item.peopley" :key="people.name"  v-show="index > 5 ? not_show : show">
                            <div class="photo">
                                <img :src="getLogo(people.people_logo_path)">
                                <p class="detail" v-show="people.article_title != null">
                                  <a class="more" :href="'http://vcbeat.top/' + people.article_id" target="_blank">
                                  <b>
                                    <i class="el-icon-right"></i>
                                  </b>
                                  </a>
                                </p>
                            </div>
                            <p class="people-name">{{people.people_name}}</p>
                            <p class="people-job over-p1">{{people.forum_display_title ? people.forum_display_title : people.en_forum_display_title}}</p>
                          </div>
                        </div>
                        <div v-if="item.peopley.length > 6"><el-button class="be-fold"  @click="changeFold(!getIsFold)">{{ getIsFold ? '收起' : '展开'}}<i :class="getIsFold ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i></el-button></div>
                    </div>
                  </div>
                </div>
            </section>
            <footerDIV></footerDIV>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import navigation from 'mcomponents/navigation.vue'
import footerDIV from 'mcomponents/footer.vue'
import moren_img from '@/assets/img/main/index/moren.png'
import links from 'mcomponents/mLinks.vue'
import Swiper from 'swiper'
import { getCompanyNewsList, getVbArticleType, getPeopleVisit } from '@/service/main.js'
export default {
  name: 'Index',
  data() {
    return {
      active: 1,
      article_list: [],
      article_type_list: [],
      people_list: [],
      not_show: false,
      show: true,
      is_links: false,
      run: false
    }
  },
  components: { navigation, footerDIV,links},
  mounted(){
    this.getVbArticleType()
    this.getPeopleVisit()
    // this.touch()
    this.$nextTick(() => {
      this.slideDown()
    })
    
  },
  beforeDestroy(){
    window.onscroll = null
  },
  computed: {
    getLogo() {
      return function(logo_path) {
        return logo_path ? this.$store.state.img_req_url + logo_path : moren_img 
      }
    },
    getArticleIndex() {
      return function(index) {
        if(index < 10) return 'TRENDS/' + '0' + index
        else return 'TRENDS/' + index
      }
    },
    getIsFold () {
      return this.not_show && this.show
    }
  },
  methods: {
    //展开收起人物动态
    changeFold(flag) {
      // flag 为true时展开 为false 时收起
      if (flag) this.not_show = true
      else this.not_show = false
    },
    //获取文章类型
    async getVbArticleType(){
      let res = await getVbArticleType({}, (error) => { this.$Message.error('请求错误') })
      if (res.status == 'success') {
        this.article_type_list = res.res
        this.active = res.res[0].id
        this.getCompanyNewsList()
      }
    },
    //企业动态
    async getCompanyNewsList() {
      let res = await getCompanyNewsList({article_type_id: this.active}, (error) => { this.$Message.error('请求错误') })
      if (res.status == 'success') this.article_list = res.res
    },
    // 人物动态
    async getPeopleVisit () {
      let res = await getPeopleVisit({}, (error) => { this.$Message.error('请求错误') })
      if (res.status == 'success') {
        this.people_list = res.res
      }
    },
    changeStatus(id) {
      this.active = id
      this.getCompanyNewsList()
    },
    //视频播放
    runVideo () {
      this.run = true
      this.is_links = true
      document.getElementById('video').play()
    },
    touch() {
      let that = this
      window.addEventListener('touchstart', function(e) {
        that.run = true
        that.is_links = true
        document.getElementById('video').play()
      })
    },
    //下滑
    slideDown() {
      $('.swiper-container').css('height', window.innerHeight + 'px')
      new Swiper('.swiper-container', {
        speed: 500,
        direction: 'vertical',
        noSwipingClass: 'scroll-wrap',
        mousewheel: true,
        autoHeight: true,
        observer: true,
        observeParents: true,
        onTransitionStart: function(){
          if(newSwiper.isEnd){ //滑到最后一页锁定向下滑动
            newSwiper.lockSwipeToNext()
          }else {
            newSwiper.unlockSwipeToNext()
          }
        }
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '../../assets/css/main/list.stylus';
@keyframes fadeUp {
  to {
    transform: translateY(-1500px)
    // transform: rotate(270deg)
  }
}
@keyframes fadeDown {
  to {
    transform: translateY(1500px)
  }
}
@keyframes slide {
  from {
    transform: translateY(-10px)
  }
  to {
    transform: translateY(10px)
  }
}
.spanFont
  display inline-block
  width 23%
  padding .08rem 0
  font-size .22rem
  list-style 1
  font-weight bold
  // color #0C142E
  color #D9BB9E
.spanActive
  border 1px solid #D9BB9E
  border-radius 18px
  color #D9BB9E
  text-align center
  padding .08rem 0
  margin-right .22rem
.list-content 
  margin-top 0
  padding-top .8rem
  width 100%
  .trends 
    margin-top -.8rem
  .info
    display flex
    margin 0 auto
    align-items center
    justify-content flex-start
    width 77.7vw
  .words
    width 77.7vw
    display flex
    margin 0 auto
    justify-content center
    img 
      width 100%
  .interview, .trend-img
    margin-top .59rem
  .concept
    margin-bottom .59rem
.first-page
  .wrap
    overflow hidden
    width 100%
    height 100vh
    background-color #232323
    display flex
    justify-content center
    align-items center
    .video-bg
      transform rotateZ(90deg)
      video
        width 100vh
        // height 100vw
        object-fit fill
    .mask
      position absolute
      width 100%
      height 100vh
      overflow hidden
      top 0
      background rgba(0,0,0, .3)
      .fadeOut-up
        width 100%
        height 50%
        background #1B1A1B
        animation fadeUp 2s ease-in-out forwards
      .fadeOut-down
        width 100%
        height 50%
        background #1B1A1B
        animation fadeDown 2s ease-in-out forwards
      .enter-video
        // width 50vw
        width 2.8rem
        // height 50vw
        background linear-gradient(90deg, #D9BB9E, #C78E66)
        height .6rem
        border-radius .1rem
        text-align center
        margin-top .5rem
        font-size .26rem
        font-family PingFang SC
        font-weight 500
        color #FFFFFF
        display flex
        justify-content center
        align-items center
        div
          width 2.76rem
          height .56rem
          line-height .56rem
          background #1B1A1B
          border-radius .1rem
      .noBack
        background none !important
      .slide-icon
        position absolute
        bottom 20px
        width 100%
        display flex
        justify-content flex-start
        img
          width .15rem
          margin-left .4rem
      .title
        z-index 1
        position absolute
        top 50%
        left 50%
        transform translate(-50%, -50%)
        img
          width 2.8rem
.second-content
  width 77.7vw
  margin .6rem auto 0
  padding-bottom 1.72rem
  .info-image
    display flex
    align-items center
    justify-content space-between
    // left 0.5375rem
    .slider-image
      margin-bottom .48rem
      img 
        height 1.95rem
  .introduce
    display flex
    flex-wrap wrap
    position relative
    margin-top 0.2rem
    .introduce-image
      width 100vw
      img 
        width 100%
    .introduce-words
      width 100vw
      height 4.49rem
      margin-top 0.76rem
      margin-bottom .97rem
      p
        font-weight 500
        color #FFFFFF
        font-size .30rem
        line-height .6rem
.third-page
  background-color #1F2330
  .list-content
    position relative
    .right-img
      position absolute
      top -1.22rem
      img
        height 2.44rem
    .trend-img
      margin-top 1.45rem
      position relative
      top .75rem
      img
        height .87rem
    .trends-content
      width 77.7vw
      margin 0 auto
      .tags
        display flex
        flex-wrap wrap
        margin-top .8rem
        span
          @extend.spanFont
          &:hover
            cursor pointer
        .active 
          @extend.spanActive
      .result
        .result-tr
          width 100%
          display flex
          flex-wrap wrap
          justify-content space-between
          padding-bottom .86rem
          .result-td
            margin-top .6rem
            width 46%
            padding .1rem
            display flex
            justify-content center
            .td-content
              width 3rem
              line-height .4rem
              font-weight bold
              .index-name
                font-size .22rem
                margin-top 5px
                color #FFFFFF
              .company-name
                font-size .26rem
                margin-top .2rem
                color #FFFFFF
              .logo
                width 100%
                height 1.884rem
                margin-top .2rem
              .article-title
                font-size .24rem
                margin-top .26rem
                color #FFFFFF
                &:hover
                  color #D9BB9E
              .article-info
                font-size .22rem
                font-weight 500
                margin-top .26rem
                color #BCBDC1
.interview-content
  width 77.7vw
  margin 0 auto
  .interview-tr
    // padding-bottom 0.6rem
    .people-type
      .type-name
        @extend.spanFont
        @extend.spanActive
    .be-fold
      width 100%
      border none
      background none
      // color #409EFF
      color #D9BB9E
    .interview-wrapper
      width 100%
      display flex
      flex-wrap wrap
      justify-content space-between
      .interview-td
        width 46%
        margin-top .47rem
        position relative
        // margin-bottom .6rem
        .photo
          height 3.25rem
          overflow hidden
          display flex 
          justify-content center
          img
            height 3.25rem
            object-fit cover
          .detail
            position absolute
            width 100%
            top 2.9rem
            padding 0
            margin 0
            a
              .el-icon-right
                color #fff
                float right
                // padding .1rem .1rem .07rem 0
                line-height .36rem
                height .36rem
                margin-right .1rem
              b
                display block
                font-size .22rem
                height .36rem
                color #fff
                line-height .36rem
                // background-color #326CDB
                background linear-gradient(90deg, #D9BB9E, #C78E66)
                &::before
                  content '相关专访'
                  font-size .22rem
                  font-weight 500
                  padding .1rem 0 .07rem .2rem
        .people-name
          font-size .26rem
          font-weight bold
          color #FFFFFF
          margin-top .2rem
        .people-job
          font-size .24rem
          font-weight 500
          color #999999
          margin-top .2rem
          margin-bottom .2rem
</style>